<template>
  <pl-modal :visible="showSavePackageDialog" @close="closeDialog" max-width="600px">
    <div slot="header">Закрытие смены</div>
    <v-form ref="savePackageForm" slot="content">
      <div key="textfield">
        <v-text-field :value="savePackageNumber" label="Номер сейф-пакета" :rules="[rules.required]" disabled>
        </v-text-field>
      </div>
      <div>
        <v-text-field
          v-model="savePackageSum"
          label="Сумма сейф-пакета"
          :rules="[rules.required]"
          type="number"
        ></v-text-field>
      </div>
      <div>
        <v-text-field
          v-if="$checkPermission($config.permissions.PERMISSIONS_CONSTANTS.EXCHANGE_CREATE)"
          v-model="exchangeSum"
          label="Сумма размена"
          :rules="[rules.required]"
          type="number"
        ></v-text-field>
      </div>
    </v-form>
    <v-layout slot="footer" align-center justify-end row fill-height>
      <v-btn class="pl-btn pl-btn_default" @click="closeDialog">
        <v-icon class="mr-1">clear</v-icon>
        Закрыть
      </v-btn>

      <v-btn class="pl-btn pl-btn_primary" @click="selectAndCloseDialog">
        <v-icon class="mr-1">done</v-icon>
        Закрыть смену
      </v-btn>
    </v-layout>
  </pl-modal>
</template>

<script>
import PLModal from '@/components/Modal/PLModal'
import form_rules from '@/mixins/form_rules'
import fullName from '@/helpers/full_name'
import store from '@/store/index'
import { mapGetters } from 'vuex'

export default {
  name: 'AddSavePackage',
  components: {
    'pl-modal': PLModal,
  },
  props: {
    opened: {
      required: true,
    },
    curentUser: {
      required: true,
    },
  },
  mixins: [form_rules],
  data: () => ({
    showSavePackageDialog: false,
    savePackageNumber: '',
    savePackageSum: '',
    exchangeSum: '',
  }),
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    closeDialog() {
      this.clearData()
      this.showSavePackageDialog = false
      this.$emit('closeSavePackageDialog')
    },
    clearData() {
      this.savePackageNumber = ''
      this.$refs.savePackageForm.reset()
    },
    async selectAndCloseDialog() {
      try {
        const formValid = this.$refs.savePackageForm.validate()
        if (formValid) {
          await this.$axios.post(`${this.$config.server}/api/crm/payments/check-self-employed-payments`)
          await store.dispatch('KKM/SESSION_CLOSE')
          await this.$axios.post(`${this.$config.server}/${this.$config.modules.crm.api.kkmCashier.sessionClosed}`, {
            safe_package_sum: this.savePackageSum,
            safe_package_code: this.savePackageNumber,
            exchange_sum: this.exchangeSum,
          })

          this.closeDialog()
        }
      } catch (e) {
        if (e.response.data.code === 1750) {
          this.$notify({
            group: 'hasBottomNavigation',
            title: 'Ошибка',
            type: 'error',
            text: 'За сегодняшний день были оплаты наличными у самозанятых. Проверьте чеки.',
          })

          return
        }
        this.$notify({
          group: 'hasBottomNavigation',
          title: 'Ошибка',
          type: 'error',
          text: 'Не удалось закрыть смену',
        })
      }
    },
    onBarcodeScanned(barcode) {
      this.savePackageNumber = barcode
    },
    init() {
      this.$barcodeScanner.init(this.onBarcodeScanned)
    },
    disable() {
      this.$barcodeScanner.destroy()
    },
  },
  watch: {
    opened(val) {
      if (val) {
        this.showSavePackageDialog = true
      }
    },
    showSavePackageDialog(val) {
      if (val) {
        this.init()
      } else {
        this.disable()
      }
    },
  },
}
</script>
